@for (message of messages; track message) {
    <!-- Elke melding een eigen kaartje in de kleur van zijn soort (token-groep notification). -->
    <div class="list notification" [class]="'notification--' + severity(message)">
        <div class="content">
            <mat-icon class="message-icon">{{ icon(message) }}</mat-icon>
            <div class="content-text">
                @if(message?.title) {
                    <h4 class="message-title">{{message.title}}</h4>
                }
                <h5 class="message-container">{{ message?.text }}</h5>
            </div>
            @if(message.showAction) {
                <button mat-icon-button class="button-action" (click)="removeMessage(message)" [attr.aria-label]="text.close">
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>
    </div>
}
